import { Component } from "@angular/core";
import { CoverStaticFlashComponent } from "../../../shared/UI/cover-static-flash/cover-static-flash.component";
import { WhyLoveFlashComponent } from "../../../shared/UI/why-love-flash/why-love-flash.component";
import { StaticCardFlashComponent } from "../../../shared/business/static-card-flash/static-card-flash.component";
import { BrowseSubjectsComponent } from "../../../shared/business/browse-subjects/browse-subjects.component";
import { StaticStudyToolsComponent } from "../../../shared/business/static-study-tools/static-study-tools.component";
import { ExploreToolsComponent } from "../../../shared/UI/explore-tools/explore-tools.component";

@Component({
  selector: "app-static-flash-cards",
  imports: [
    CoverStaticFlashComponent,
    WhyLoveFlashComponent,
    StaticCardFlashComponent,
    // BrowseSubjectsComponent,
    ExploreToolsComponent,
  ],
  templateUrl: "./static-flash-cards.component.html",
  styleUrl: "./static-flash-cards.component.css",
})
export class StaticFlashCardsComponent {}
